import { ReactComponent as TableIcon } from './table.svg';

export default TableIcon;
